import Storage from '@/config/storage';

/**
 * all localStorage/sessionStorage operatino in this service.
 * @private private class using in auth.service
 * @kind cache.service
 */
class StorageCache {
  constructor() {
    this.store = Storage.getLocalStorage();
  }

  // all clear
  clear() {
    this.store.clear();
  }

  // current language
  setCurLang(code) {
    return this.store.set('LANGUAGE', code);
  }

  getCurLang() {
    return this.store.get('LANGUAGE');
  }

  removeCurLang() {
    return this.store.remove('LANGUAGE');
  }
  // current language index
  setCurIndex(code) {
    return this.store.set('LANGUAGEINDEX', code);
  }

  getCurIndex() {
    return this.store.get('LANGUAGEINDEX');
  }

  removeCurIndex() {
    return this.store.remove('LANGUAGEINDEX');
  }
}

export default new StorageCache();
